/**
 * Which app this build is.
 *
 * One codebase ships as three apps — the customer app, the driver app, and the
 * admin app — selected at build time with VITE_APP_TARGET. The driver and admin
 * builds boot straight into their role (sign in → their dashboard) and hide the
 * customer storefront/onboarding, while sharing all the same components and API.
 *
 *   VITE_APP_TARGET=customer  (default) — the shopper app
 *   VITE_APP_TARGET=driver              — the delivery-partner app
 *   VITE_APP_TARGET=admin               — the operations/admin app
 */
export const APP_TARGET = (import.meta.env.VITE_APP_TARGET || 'customer').toLowerCase();

export const isCustomerApp = APP_TARGET === 'customer';
export const isDriverApp = APP_TARGET === 'driver';
export const isAdminApp = APP_TARGET === 'admin';

/** Where a signed-in user of THIS app build belongs by default. */
export function homePathForRole(role) {
  if (isDriverApp) return '/driver';
  if (isAdminApp) return '/admin';
  // Customer app: route by the account's role so an admin/driver who signs into
  // the shopper app still lands somewhere sensible.
  if (role === 'driver') return '/driver';
  if (role === 'admin' || role === 'app_admin') return '/admin';
  return '/app';
}
